import { render, staticRenderFns } from "./foots.vue?vue&type=template&id=7b658422&scoped=true&"
import script from "./foots.vue?vue&type=script&lang=js&"
export * from "./foots.vue?vue&type=script&lang=js&"
import style0 from "./foots.vue?vue&type=style&index=0&id=7b658422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b658422",
  null
  
)

export default component.exports